<template>
  <div v-if="invoice.order" class="ls-theme-cyanogen container subscribe-wrapper">
    <header class="main-header ls-md-margin-top">
      <h1 class="trade-name" >{{ basicSeller.trade_name || basicSeller.name }}</h1>
      <h3 class="subtitle">{{ $t('payments.messages.finalize_payment') }}</h3>
    </header>
    <div class="checkout-details col-md-12">
      <div class="col-md-8 col-sm-6 ls-no-padding-left ls-md-margin-top">
        <div class="ls-md-margin-bottom col-md-12 ls-txt-center">
          <h2 class="">{{ $t('subscribe.messages.almost_there') }}</h2>
        </div>
        <div class="col-md-3"></div>
        <div class="ls-txt-center col-md-6">
          <button class="btn btn-act btn-lg ls-full-width ls-md-margin-bottom" v-on:click="openBank()">{{ $t('subscribe.buttons.redirect_to_bank') }}</button>
        </div>
        <ul class="payment-info col-md-12">
          <li class="ls-md-margin-bottom" v-for="step in steps">
            <div>
              <i :class="step.icon" aria-hidden="true"></i>
              <p class="ls-no-margin ls-txt-justify" v-html="step.description">{{ step.description }}</p>
            </div>
          </li>
        </ul>
      </div>
      <div class="col-md-4 col-sm-6 ls-no-padding-left ls-no-padding-right">
        <div class="full-height ls-no-padding-left ls-no-padding-right">
          <invoice-details class="ls-md-margin-bottom" :invoice="invoice"></invoice-details>
        </div>
      </div>
    </div>
    <router-link :to="{ name: 'payment', params: { id: invoice.id }}" class="ls-text-sm ls-md-space ls-no-padding ls-md-margin-top"><p><a>{{ $t('payments.messages.change_method') }}</a></p></router-link>
  </div>
</template>
<script>
  import { mapGetters, mapMutations, mapActions } from 'vuex'
  import InvoiceDetails from './components/InvoiceDetails.vue'
  import IconSuccess from 'src/app/components/shareds/icon-animate/success'

  export default {
    name: 'Transfer',
    components: { IconSuccess, InvoiceDetails },
    data () {
      return {
        steps: [
          {
            description: this.$t('subscribe.messages.transfer_instructions'),
            icon: 'fa fa-exchange'
          },
          {
            description: this.$t('subscribe.messages.payment_confirmation_automatically_transfer'),
            icon: 'fa fa-check-circle-o'
          },
          {
            description: this.$t('subscribe.messages.signature_will_only_be_approved_after_payment_confirmation'),
            icon: 'fa fa-file-text-o'
          }
        ]
      }
    },
    methods: {
      ...mapMutations(['clearFlash', 'addFlash']),
      ...mapActions(['loadSellerData', 'loadInvoiceById', 'pay', 'loadSetting']),
      openBank () {
        window.open(this.invoice.order.gateway_payment_url, '_blank')
      },
      changePaymentMethod () {
        this.clearFlash()
        this.$parent.$data.transferDone = false
        this.$parent.$data.choosePayment = true
      },
      redirectPayment () {
        if (!this.invoice.order) {
          this.$router.push('/payment/invoice/' + this.$route.params.id)
        }
      }
    },
    mounted () {
      this.redirectPayment()
    },
    computed: {
      ...mapGetters(['basicSeller', 'invoice'])
    }
  }
</script>
<style lang="scss" scoped>
  .checkout-details {
    display: flex;
    justify-content: stretch;
    padding: 15px;
    @media screen and (max-width: 768px) {
      display: block;
      padding: 0;
      .order-box {
        margin-bottom: 40px;
      }
    }
  }
  .order-box {
    display: flex;
    flex-wrap: wrap;
    align-content: space-between;
    border-radius: 4px;
    border: 1px solid #dddddd;
    padding: 15px;
    > * {
      display: block;
      width: 100%;
    }
    @media screen and (max-width: 768px) {
      background: rgba(0, 0, 0, 0.11);
      border-radius: 0;
      text-align: center;
    }
  }
  .ls-btn {
    margin: 0 auto;
  }
  .btn {
    border: none;
    display: block;
    margin: 0 auto;
  }
  .bar-code {
    padding: 15px;
    font-size: 20px;
    width: 100%;
    color: #717787;
    text-align: center;
  }
  @media screen and (max-width: 768px) {
    .ls-box {
      -webkit-animation: cd-bounce-2 0.6s;
      -moz-animation: cd-bounce-2 0.6s;
      animation: cd-bounce-2 0.6s;
      border: none;
      padding: 0;
    }
  }
  .payment-info {
    list-style: none;
    div {
      display: flex;
      align-items: center;
    }
    i {
      font-size: 40px;
      max-width: 50px;
      display: inline-block;
      padding: 0px 15px 0px 0px;
      @media screen and (max-width: 768px) {
        font-size: 28px;
        display: inline-block;
        padding: 0px 30px 27px 0px;
      }
    }
  }
  .ls-btn[disabled] {
    transform: scale(1.2);
  }
  .check-mark {
    width: 80px;
    height: 130px;
    margin: 0 auto;
  }
  @-webkit-keyframes rotatePlaceholder {
    0% {
      transform: rotate(-45deg);
      -webkit-transform: rotate(-45deg);
    }
    5% {
      transform: rotate(-45deg);
      -webkit-transform: rotate(-45deg);
    }
    12% {
      transform: rotate(-405deg);
      -webkit-transform: rotate(-405deg);
    }
    100% {
      transform: rotate(-405deg);
      -webkit-transform: rotate(-405deg);
    }
  }
  @keyframes rotatePlaceholder {
    0% {
      transform: rotate(-45deg);
      -webkit-transform: rotate(-45deg);
    }
    5% {
      transform: rotate(-45deg);
      -webkit-transform: rotate(-45deg);
    }
    12% {
      transform: rotate(-405deg);
      -webkit-transform: rotate(-405deg);
    }
    100% {
      transform: rotate(-405deg);
      -webkit-transform: rotate(-405deg);
    }
  }
  @media only screen and (min-width: 1170px) {
    /* inverse bounce effect on even content blocks */
    .cssanimations .cd-timeline-block:nth-child(even) .cd-timeline-content.bounce-in {
      -webkit-animation: cd-bounce-2-inverse 0.6s;
      -moz-animation: cd-bounce-2-inverse 0.6s;
      animation: cd-bounce-2-inverse 0.6s;
    }
  }
  @-webkit-keyframes cd-bounce-2 {
    0% {
      opacity: 0;
      -webkit-transform: translateX(-100px);
    }

    60% {
      opacity: 1;
      -webkit-transform: translateX(20px);
    }

    100% {
      -webkit-transform: translateX(0);
    }
  }
  @-moz-keyframes cd-bounce-2 {
    0% {
      opacity: 0;
      -moz-transform: translateX(-100px);
    }

    60% {
      opacity: 1;
      -moz-transform: translateX(20px);
    }

    100% {
      -moz-transform: translateX(0);
    }
  }
  @keyframes cd-bounce-2 {
    0% {
      opacity: 0;
      -webkit-transform: translateX(-100px);
      -moz-transform: translateX(-100px);
      -ms-transform: translateX(-100px);
      -o-transform: translateX(-100px);
      transform: translateX(-100px);
    }

    60% {
      opacity: 1;
      -webkit-transform: translateX(20px);
      -moz-transform: translateX(20px);
      -ms-transform: translateX(20px);
      -o-transform: translateX(20px);
      transform: translateX(20px);
    }

    100% {
      -webkit-transform: translateX(0);
      -moz-transform: translateX(0);
      -ms-transform: translateX(0);
      -o-transform: translateX(0);
      transform: translateX(0);
    }
  }
  @-webkit-keyframes cd-bounce-2-inverse {
    0% {
      opacity: 0;
      -webkit-transform: translateX(100px);
    }

    60% {
      opacity: 1;
      -webkit-transform: translateX(-20px);
    }

    100% {
      -webkit-transform: translateX(0);
    }
  }
  @-moz-keyframes cd-bounce-2-inverse {
    0% {
      opacity: 0;
      -moz-transform: translateX(100px);
    }

    60% {
      opacity: 1;
      -moz-transform: translateX(-20px);
    }

    100% {
      -moz-transform: translateX(0);
    }
  }
  @keyframes cd-bounce-2-inverse {
    0% {
      opacity: 0;
      -webkit-transform: translateX(100px);
      -moz-transform: translateX(100px);
      -ms-transform: translateX(100px);
      -o-transform: translateX(100px);
      transform: translateX(100px);
    }

    60% {
      opacity: 1;
      -webkit-transform: translateX(-20px);
      -moz-transform: translateX(-20px);
      -ms-transform: translateX(-20px);
      -o-transform: translateX(-20px);
      transform: translateX(-20px);
    }

    100% {
      -webkit-transform: translateX(0);
      -moz-transform: translateX(0);
      -ms-transform: translateX(0);
      -o-transform: translateX(0);
      transform: translateX(0);
    }
  }
  .green {
    color: green;
  }
</style>



// WEBPACK FOOTER //
// TransferDone.vue?0444ab95